import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

import { ITextTileData } from '../../models/i-card';

@Component({
  selector: 'vantage-platform-category-text',
  templateUrl: './category-text.component.html',
  styleUrls: ['./category-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryTextComponent implements OnInit {
  @Input() data: ITextTileData;

  constructor() {}

  ngOnInit(): void {}
}
